import GridSpinner from 'components/UI/GridSpinner'
import { Container, Typography } from 'gu-ui-kit'
import omit from 'lodash/omit'
import PromisedPaymentRequestForm from 'modules/Forms/Finance/PromisedPaymentRequest'
import validationSchema from 'modules/Forms/Finance/PromisedPaymentRequest/validationSchema'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import validator from 'utils/asyncValidator'
import styles from 'modules/Finance/PromisedPayment/Request/request.module.scss'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import PageHeader from 'components/PageHeader'
import clsx from 'clsx'

const PromisedPaymentRequest = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()

  const { i18n, loadingCreditSettings, promised_payments_settings } = useSelector((state) => ({
    i18n: state['app'].i18n,
    loadingCreditSettings: state['finance/promised-payment'].loadingCreditSettings,
    promised_payments_settings: state['finance/promised-payment'],
  }))

  useEffect(() => {
    dispatch({ type: 'PROMISED_PAYMENT/FETCH_SETTINGS' })
  }, [i18n])

  return (
    <Container className={styles['container']}>
      {loadingCreditSettings ? (
        <GridSpinner />
      ) : !promised_payments_settings.available ? (
        <div>
          <PageHeader>{t('promised_payment::request.header')}</PageHeader>
          <Typography
            variant={'Body-20'}
            className={clsx('margin-top-8', 'margin-bottom-16')}
            component={
              <span
                dangerouslySetInnerHTML={{
                  __html: t('promised_payment::request.not_available', {
                    tickets_url: pathGen(ROUTES.TICKET_NEW),
                    rules_url: pathGen(ROUTES.PROMISED_PAYMENT_TERMS),
                  }),
                }}
              />
            }
          />
        </div>
      ) : (
        <PromisedPaymentRequestForm
          creditSettings={{
            ...omit(promised_payments_settings, ['available']),
          }}
          initialValues={{ amount: promised_payments_settings.min_amount }}
          asyncValidate={validator(validationSchema(promised_payments_settings))}
          onClose={() => global.history.go(-1)}
        />
      )}
    </Container>
  )
}

export default PromisedPaymentRequest
